module.exports = __webpack_public_path__ + "img/mrm.55001ddd.png";